import { ReactNode } from 'react'

import { combineClassnames } from 'app/common/presentation/combineClassnames'

import styles from './CardHeader.module.scss'

interface CardHeaderProps {
  actions?: ReactNode
  className?: string
  icon?: ReactNode
  title: ReactNode
  titleSuffix?: ReactNode
  supportText?: ReactNode
}

const CardHeader = ({
  actions,
  className,
  icon,
  title,
  titleSuffix,
  supportText,
}: CardHeaderProps) => (
  <header className={combineClassnames(styles.cardHeader, className)}>
    <div className={styles.titleGroup}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <h2>{title}</h2>
      {titleSuffix}
    </div>
    {(supportText != null || actions != null) && (
      <div className={styles.actions}>
        {supportText && <span className={styles.supportText}>{supportText}</span>}
        {actions}
      </div>
    )}
  </header>
)

export default CardHeader
export type { CardHeaderProps }
